import gql from "graphql-tag";

const FIELDS = `
  id
  project_id
  slug
  active
  background_uri
  showcase_name
  showcase_label
  showcase_subtitle
  showcase_description
  showcase_solution
  showcase_objectives
  showcase_cover_uri
  showcase_gallery
  created_at
  remote_status
  remote_error
`;

export const listForProject = gql`
  query ProjectShareLinks($id: ID!) {
    project(id: $id) {
      id
      name
      share_links {
        ${FIELDS}
      }
    }
  }
`;

export const create = gql`
  mutation CreateShareLink($input: CreateShareLinkInput!) {
    createShareLink(input: $input) {
      ${FIELDS}
    }
  }
`;

export const update = gql`
  mutation UpdateShareLink($input: UpdateShareLinkInput!) {
    updateShareLink(input: $input) {
      ${FIELDS}
    }
  }
`;

export const publish = gql`
  mutation PublishShareLink($input: ID!) {
    publishShareLink(input: $input) {
      ${FIELDS}
    }
  }
`;

export const ftpCheck = gql`
  query ShareFtpCheck {
    shareFtpCheck {
      configured
      ok
      dir
      missing
      entries
      error
    }
  }
`;

export const del = gql`
  mutation DeleteShareLink($input: ID!) {
    deleteShareLink(input: $input) {
      id
    }
  }
`;
